import React, { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { sendRequest } from '../../../src/hooks/fetchData';
import { useUserContext } from '../../store/user_context';
import {  useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Nav from '../../layouts/nav';

const UserRegister = ({ initialData } = {}) => {
  const navigate = useNavigate();
  const { setUser } = useUserContext();
  const data = initialData || state || {};

  const [form, setForm] = useState({
    Email: data.email || data.Email || '',
    Name: data.name || data.Name || '',
    GoogleName: data.name || data.GoogleName || '',
    NagwaId: data.NagwaId || '',
    Title: data.Title || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const command = {
    Email: form.Email || '',
    Name: form.GoogleName || form.Name || '',
    GoogleName: form.GoogleName || '',
    NagwaId: form.NagwaId || '',
    Title: form.Title || '',
  };
 
  try {
    const apiUrl = `${import.meta.env.VITE_API_URL}${import.meta.env.VITE_register_user}`;
    const { done, isError } = await sendRequest(apiUrl, 'POST', command, {});

    if (done && !isError) {
      const confirmed = await showSuccess('تم تسجيل المستخدم بنجاح');

      if (confirmed) {
        const fetchedUser = await  fetchUserByEmail(form.Email);
        if (fetchedUser) {
          setUser(fetchedUser);
          Cookies.set('user_data', JSON.stringify(fetchedUser));
          navigate('/');
        } else {
          await showError('فشل تسجيل الدخول بعد التسجيل، حاول مرة أخرى');
        }
      }
    } else {
      await showError('فشل التسجيل، حاول مرة أخرى');
    }
  } catch (err) {
    console.error(err);
    await showError('حدث خطأ غير متوقع، حاول مرة أخرى');
  }
};
 
  const showError = async (message) => {
    await swal({
      title: 'خطأ',
      text: message || 'فشل التسجيل، حاول مرة أخرى',
      icon: 'error',
      buttons: { confirm: { text: 'موافق', className: 'swal-button--confirm' } },
    });
  };
 
  const showSuccess = async (message) => {
    return swal({
      title: 'نجاح',
      text: message || 'تم تسجيل المستخدم بنجاح',
      icon: 'success',
      buttons: { confirm: { text: 'موافق', className: 'swal-button--confirm' } },
    });
  };


  const fetchUserByEmail = async (email) => {
        const url = `${import.meta.env.VITE_API_URL}${import.meta.env.VITE_get_user_by_email}?email=${encodeURIComponent(email)}`;

        const { done, isError, error, data } = await sendRequest(url);

        if (done && !isError && data) {
            return data;
        } else {
            return null;
        }
    };


  return (
    <>
           <header>
                <div className="container">
                    <a href="/" className="logo">
                        <img src="https://otlob.nagwa.com/Content/images/logo.svg" alt="" />
                    </a>
                     
                </div>
            </header>
            <div className="page">
    <section className="banner">
                    <div className="container">
                        <div className="text">
                            <h1>اطلب الأكل اللي نفسك فيه</h1>
                                 
                        </div>
                    </div>
                </section>
    <section className="main_content">
      <div className="container">
        <h1 className="page-title">تسجيل مستخدم جديد</h1>
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>البريد الالكتروني</label>
            <div className="field"><div>{form.Email}</div></div>
          </div>
          <div className="form-group">
            <label>الاسم</label>
            <div className="field"><div>{form.GoogleName || form.Name}</div></div>
          </div>
          <div className="form-group">
            <label>رقم الموظف</label>
            <div className="field">
              <input className="form-control" name="NagwaId" type="number" value={form.NagwaId} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-group">
            <label>الوظيفة</label>
            <div className="field">
              <input className="form-control" name="Title" type="text" value={form.Title} onChange={handleChange} maxLength={50} required />
            </div>
          </div>
          <input type="submit" value="تسجيل" className="btn btn-primary" />
        </form>
      </div>
    </section>
            </div>
            </>
  );
};

export default UserRegister;
